export default __webpack_public_path__ + "static/media/logo-text.83483085.svg";